import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SharedService } from '../../../../services/shared/shared.service';
import { DetailsService } from '../../details.service';

declare let novSelect: any;

@Component({
  selector: 'novelist-fullrecord',
  templateUrl: './novelist-fullrecord.component.html',
  styleUrls: ['./novelist-fullrecord.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NovelistFullRecordComponent implements OnInit {
  /**   Displays Novelist for the first isbn supplied   */
  @Input() isbn: string | string[];
  @Input() label: string;

  loader: boolean;
  error: string;
  novelist: string;

  private _isbn: string;

  constructor(
    private _detailService: DetailsService,
    private _sharedService: SharedService,
  ) {}

  ngOnInit(): void {
    if (Array.isArray(this.isbn)) {
      this._isbn = this.isbn[0];
    } else {
      this._isbn = this.isbn;
    }

    this.getNovelistCredentials();
  }

  async getNovelistCredentials(): Promise<void> {
    this.loader = true;
    await this._sharedService.addScriptToIndex(
      'novelistScript',
      'https://imageserver.ebscohost.com/novelistselect/ns2init.js',
    );
    this.novelist = `<div data-novelist-novelistselect="${this._isbn}"></div>`;
    this._detailService.getNovelistCredentials().subscribe(
      (result) => {
        !result.data.profile || !result.data.password
          ? this.getNovelistErrorHandler()
          : this.getNovelist(result.data.profile, result.data.password);
      },
      () => {
        this.getNovelistErrorHandler();
      },
    );
  }

  getNovelist(profile: string, password: string) {
    // hack to check if need to display error since EBSCO isn't yet exposing error events
    const novelistCall = setTimeout(() => {
      this.getNovelistErrorHandler();
    }, 10000);

    novSelect.loadContentForQuery(
      {
        ClientIdentifier: this._isbn,
        ISBN: this._isbn,
        version: '2.3',
      },
      profile,
      password,
      (response) => {
        clearTimeout(novelistCall);
        this.loader = false;

        if (!response.length) {
          this.error = 'Novelist has not sent recommendations for this title';
        }
      },
    );
  }

  getNovelistErrorHandler(): void {
    this.loader = false;
    this.error =
      "We can't reach the Novelist recommendation service at this time. Please notify the library.";
  }
}
